import { render } from "./instore.vue?vue&type=template&id=f583debe"
import script from "./instore.vue?vue&type=script&lang=js"
export * from "./instore.vue?vue&type=script&lang=js"

import "./instore.vue?vue&type=style&index=0&id=f583debe&lang=less"

import exportComponent from "D:\\AICodeSpace\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__